import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Lock } from 'lucide-react';
import { Button } from '@/common/components/ui/button';
import { CancelProductDialog } from '../cancel-product-dialog/CancelProductDialog';

interface PanelFooterProps {
  isActive: boolean;
  productName: string;
  onClose: (() => void) | undefined;
  onCancel: (() => void) | undefined;
}

export function PanelFooter({ isActive, productName, onClose, onCancel }: PanelFooterProps) {
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!isActive) return null;

  return (
    <>
      <div className="border-t border-gray-100 px-4 sm:px-6 py-4 flex justify-between items-center gap-3 bg-white shrink-0">
        {onCancel ? (
          <Button
            variant="ghost"
            className="text-red-600 hover:text-red-700 hover:bg-red-50"
            onClick={() => setDialogOpen(true)}
          >
            <Trans>Cancel subscription</Trans>
          </Button>
        ) : (
          <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <Lock size={11} className="shrink-0" />
            <Trans>You don&apos;t have permission to manage this product</Trans>
          </span>
        )}
        <Button variant="outline" onClick={onClose}>
          <Trans>Close</Trans>
        </Button>
      </div>

      {onCancel && (
        <CancelProductDialog
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          productName={productName}
          onConfirm={onCancel}
        />
      )}
    </>
  );
}
